import { EnviarContactoRequest } from "../../../interfaces/interfaceTemplateApi";
import api from "../api/apiSystem";

export const postEnviarContacto = async (accessToken: string, data: EnviarContactoRequest) => {
  try {
    const url = "/micrositios-gasco-bff/contacto";
    const headers = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    const response = await api.post(url, data, headers);

    return response.data;
  }
  catch (error: any) {
    console.error("Error al enviar el contacto:", error);
    throw error;
  }
};
